import {
  selectDiscoveryCurrency,
  selectDiscoveryId,
  selectRequestError,
  selectRequestState
} from "../../../store/reducers";
import { bindActionCreators, compose } from "redux";
import { connect } from "react-redux";
import { useEffect } from "react";
import { useString as s } from "../../StringProvider";
import {
  createDiscoveryKPI,
  stopCreatingKPI
} from "../../../store/actions/create-kpis";
import NewKPIForm from "./NewKPIForm";
import Form from "../../Form";
import KPIModal from "./KPIModal";
import actionTypes from "../../../store/actionTypes";
import useLoadingState from "../../../utils/use-loading-state";
import Notification from "../../Notification";

const CreateKPIModal = ({
  discoveryId,
  loadingState,
  order,
  error,
  createDiscoveryKPI,
  stopCreatingKPI,
  currency
}) => {
  const errorText = s("createKPI.popup.error.text", "Failed to create outcome");
  const successText = s(
    "createKPI.popup.success.text",
    "Card added! Changes will be applied to the current value case only."
  );
  const [form] = Form.useForm();

  useEffect(() => {
    form.resetFields();
  }, []);

  useLoadingState(
    loadingState,
    () => {
      Notification.success(successText);
      stopCreatingKPI();
    },
    () => {
      if (!error || error.status !== 409) {
        Notification.error(errorText);
      }
    }
  );

  const onFinish = ({
    name,
    benefitValueDriverDescription,
    lowImpactPercentage,
    highImpactPercentage,
    categoryCode,
    challengeMappings,
    detailText
  }) => {
    const data = {
      lowImpactPercentage,
      highImpactPercentage,
      definition: {
        name,
        benefitValueDriverDescription,
        categoryCode,
        order,
        challengeMappings,
        detailText
      }
    };

    createDiscoveryKPI({
      discoveryId,
      data
    });
  };

  return (
    <KPIModal open={true} data-cy={"create-kpi-modal"}>
      <NewKPIForm
        currency={currency}
        onFinish={onFinish}
        onCancel={stopCreatingKPI}
        form={form}
        error={error}
      />
    </KPIModal>
  );
};

const mapStateToProps = (state) => ({
  discoveryId: selectDiscoveryId(state),
  loadingState: selectRequestState(
    state,
    actionTypes.DISCOVERY_CREATE_KPI_REQUEST
  ),
  error: selectRequestError(state, actionTypes.DISCOVERY_CREATE_KPI_REQUEST),
  order: 0,
  currency: selectDiscoveryCurrency(state)
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      createDiscoveryKPI,
      stopCreatingKPI
    },
    dispatch
  );

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  CreateKPIModal
);
